import { render, staticRenderFns } from "./ViewDealForm.vue?vue&type=template&id=1b5b9826&scoped=true&"
import script from "./ViewDealForm.vue?vue&type=script&lang=js&"
export * from "./ViewDealForm.vue?vue&type=script&lang=js&"
import style0 from "./ViewDealForm.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ViewDealForm.vue?vue&type=style&index=1&id=1b5b9826&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5b9826",
  null
  
)

export default component.exports